import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { App } from "antd";
import { crossAccessService } from "../services/cross-access.service";
import type {
	CreateCrossAccessRequest,
	ListCrossAccessParams,
	UpdateCrossAccessRequest,
} from "../types";

const QUERY_KEY = "cross-access";

export function useCrossAccessList(params: ListCrossAccessParams) {
	return useQuery({
		queryKey: [QUERY_KEY, params],
		queryFn: () => crossAccessService.list(params),
	});
}

export function useCrossAccess(id: string) {
	return useQuery({
		queryKey: [QUERY_KEY, id],
		queryFn: () => crossAccessService.getById(id),
		enabled: !!id,
	});
}

export function useCreateCrossAccess() {
	const { message } = App.useApp();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (data: CreateCrossAccessRequest) => crossAccessService.create(data),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
			message.success("Kirish huquqi yaratildi");
		},
		onError: () => {
			message.error("Kirish huquqi yaratishda xatolik yuz berdi");
		},
	});
}

export function useUpdateCrossAccess() {
	const { message } = App.useApp();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: ({ id, data }: { id: string; data: UpdateCrossAccessRequest }) =>
			crossAccessService.update(id, data),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
			message.success("Kirish huquqi yangilandi");
		},
		onError: () => {
			message.error("Kirish huquqi yangilashda xatolik yuz berdi");
		},
	});
}

export function useDeleteCrossAccess() {
	const { message } = App.useApp();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (id: string) => crossAccessService.delete(id),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
			message.success("Kirish huquqi o'chirildi");
		},
		onError: () => {
			message.error("Kirish huquqi o'chirishda xatolik yuz berdi");
		},
	});
}
